export default __webpack_public_path__ + "static/media/marketing.2621552a.svg";